import { Marker, Popup } from "react-leaflet";

const markerIcon = L.icon( {
	iconUrl: cnt_sindicats_map_block.imagePath + 'pin.svg',
	iconRetinaUrl: cnt_sindicats_map_block.imagePath + 'pin.svg',
	iconSize: [25, 41],
	iconAnchor: [12, 41],
	popupAnchor: [1, - 34],
	tooltipAnchor: [16, - 28],
	shadowSize: [41, 41]
} )

export default function Syndicate( { syndicate } ) {
	return (
		<Marker
			icon={ markerIcon }
			position={ syndicate.location }
		>
			<Popup>
				{ syndicate.name }<br/>{ syndicate.phone }<br/>{ syndicate.address }<br/>
				<a href={ 'mailto:' + syndicate.email }>{ syndicate.email }</a><br/>
				<a href={ syndicate.url }>{ syndicate.url }</a><br/>
				{ syndicate.opening_hours.split( '\n' ).map( ( value ) => <>{ value }<br/></> ) }
			</Popup>
		</Marker>
	);
}
